import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FnModalService, FnUtilService, FnTableConfig, FnTableMetaData, FnToasterService, TABLE_ACTION_TYPE, TableAction } from 'foundation';
import { Subject } from 'rxjs';
import { EOProduct } from '../../../modal/entity.modal';
import { PosHttpService } from '../../../services/pos.http.service';

@Component({
  selector: 'app-day-app-status',
  templateUrl: './day-app-status.component.html',
  styleUrl: './day-app-status.component.scss'
})
export class DayAppStatusComponent {
 constructor(private fnModalSvcs: FnModalService, public datepipe: DatePipe, private toaster: FnToasterService, private fnutilservice: FnUtilService, private route: ActivatedRoute, private router: Router, private posHttpSvcs: PosHttpService) {
  }

  loading = false;
  startDate: any;
  endDate: any;
  currentDate = new Date();
  selectProduct: any;
  selectIdenNo: any;
  showData = true;
  productArray: EOProduct[] = [];
  idenNoArray: any[] = [];
  maxDateRange = new Date();
  isDisabled = false;
  uiMap = {
    isDataLoaded: false,
  };
  description = '';

  ngOnInit() {
    this.dateRangeObject.startDate.setDate(this.currentDate.getDate());
    this.dateRangeObject.endDate.setDate(this.currentDate.getDate());
    this.startDate = this.datepipe.transform(this.dateRangeObject.startDate, 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(this.dateRangeObject.endDate, 'yyyy-MM-dd');
    this.loadEOProduct();
  }

  backtoDashboard() {
    this.router.navigate(['/app/main/dashboard']);
  }

  dateRangeObject = {
    startDate: new Date(),
    endDate: new Date()
  };

  changeDate(event: any) {
    this.startDate = this.datepipe.transform(event.startDate, 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(event.endDate, 'yyyy-MM-dd');
  }

  loadEOProduct() {
    this.posHttpSvcs.authGet('v1/ui/loadProductName', 'loadProductName').subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('Product name not loaded');
        return;
      }
      this.productArray = resp.data;
    });
  }

  getIdenNoData() {
    this.selectIdenNo = '';
    this.posHttpSvcs.authPost('v1/ui/loadIdenNo', 'loadIdenNo', this.selectProduct).subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('Product not Selected');
        return;
      }
      this.idenNoArray = resp.data;
    })
  }

  getHistData(selectIdenNo: number) {
    if (this.fnutilservice.isEmptyObject(this.startDate) && this.fnutilservice.isEmptyObject(this.endDate)) {
      this.toaster.error('Selected Date cannot be null');
      return;
    }
    if (this.fnutilservice.isEmptyObject(this.selectIdenNo) && this.fnutilservice.isEmptyObject(this.description)) {
      this.toaster.error('Please select some value');
      return;
    }
    const requestMap = {
      startDate: this.startDate,
      endDate: this.endDate,
      pk: selectIdenNo,
      description: this.description
    }
    this.posHttpSvcs.authPost('v1/ui/loadDayHistory', 'loadDayHistory', requestMap).subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('Something went wrong');
        this.uiMap.isDataLoaded=false;
        return;
      }
      this.dayHistoryArray = resp.data;
      this.refreshTableData();
      this.uiMap.isDataLoaded=true;
    })
    
  }

  refreshTableData() {
        if (this.config.tableAction.closed) {
          this.config.tableAction = new Subject<TableAction>();
        }
        this.config.tableAction.next({
          data: this.dayHistoryArray,
          action: TABLE_ACTION_TYPE.REFRESH,
        });
      }

  dayHistoryArray = [];

  config: FnTableConfig = {
    uniqueKey: 'primaryKey',
    defaultSortKey: 'primaryKey',
    tableAction: new Subject(),
    hideAction: true
  };

  rowMetaArray: FnTableMetaData[] = [
    {
      key: 'primaryKey',
      description: 'Primary Key',
      isHidden: true,
      isSortable: true,
      type: 'number',
    },
    {
      key: 'statusType',
      description: 'Status Type',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'alertDesc',
      description: 'Alert Desc',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'alertOccurance',
      description: 'Count',
      type: 'number',
      isSortable: true,
    },
    {
      key: 'busiDate',
      description: 'Alert Date',
      type: 'datetime',
      isSortable: true,
    },
    {
      key: 'firstOccuredAt',
      description: 'First OccuredAt',
      type: 'datetime',
      isSortable: true,
    },
    {
      key: 'lastOccuredAt',
      description: 'Last OccuredAt',
      type: 'datetime',
      isSortable: true,
    },
    {
      key: 'longestTime',
      description: 'Max Duration',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'ttlTime',
      description: 'Total Time',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'source',
      description: 'Source',
      type: 'string',
      isSortable: true,
    }
  ];
}
